const { ENABLE_SUPPORTING_DOCUMENTATION } = require('../apps/grant_request_form/feature_flags.js')

App.GrantRequestsTable = class extends App.DataTable {
  constructor(table, dataSourceUrl, noDataText, inProgress = false) {
    let columns = [
      {
        sortable: false,
        render: function ( data, type, full, meta ) {
          let text = full.can_edit? 'Edit' : 'View'
          let link = full.can_edit ?
            `/organizations/${full.organization_id}/grant_requests/${full.id}/edit`
          :
            `/organizations/${full.organization_id}/grant_requests/${full.id}`

          return `<a href="${link}" class="btn btn-xs btn-muted-blue" >${text}</a>`;
        },
        width: '48px'
      },
      {
        data: "id",
        width: '60px',
        orderable: true
      },
      {
        data: "description",
        width: '120px',
        orderable: true
      },
      {
        data: "total_cost",
        orderable: true
      },
      {
        data: "requested_by",
        orderable: true
      },
      {
        data: "created_at",
        width: '130px',
        orderable: true
      }
    ];

    //  columns
    if (inProgress) {
      columns.push({
        data: "updated_at",
        width: '80px',
        orderable: true
      });

      columns.push({
        sortable: false,
        render: function ( data, type, full, meta ) {
          if (!full.can_delete) {
            return `<button disabled class="btn btn-xs" style="opacity: 0.4; color: #444;">
                      Delete
                    </button>`;
          }

          return `<a href="/organizations/${full.organization_id}/grant_requests/${full.id}/"
                     data-method="delete"
                     data-title="Confirm Grant Request Deletion"
                     data-confirm="Are you sure you want to delete this grant request?"
                     data-remote="true"
                     data-behavior="propagate-click-event grant_request_delete_link"
                     rel="nofollow"
                     class="btn btn-xs btn-danger">

                    Delete
                  </a>`
        },
        width: '48px'
      });
    }

    if (!inProgress) {
      columns.push({
        data: "submitted_at",
        width: '80px'
      });

      columns.push({
        sortable: false,
        visible: ENABLE_SUPPORTING_DOCUMENTATION,
        render: function ( data, type, full, meta ) {
          let subject = encodeURIComponent(`Grant Request: Proof of Purchase - #${full.member_number}-${full.id}`)
          return `<a href="mailto:grants@vrsa.us?subject=${subject}"
                    class='btn btn-primary btn-normalcase btn-xs'>
                    Submit Proof of Purchase
                  </a>`
        },
        // width: 'px'
      });
    }

    const noData = '<span class="fa fa-info-sign"></span><p>' + noDataText + '</p>';

    super({ table: table,
            dataSourceUrl: dataSourceUrl,
            columns: columns,
            noData: noData,
            initialOrder: !inProgress ? [6, 'desc'] : null // Default order by Submitted column
          });
  }
}

$(document).on('turbo:load', function() {
  if($(".grant_requests.index").length == 0) return;

  var submittedRequestsTable = new App.GrantRequestsTable(
    $("#submitted-requests"),
    '/grant_requests/data_table/submitted',
    "No requests have been submitted.",
    false
  );
  submittedRequestsTable.render();

  var requestsInProgressTable = new App.GrantRequestsTable(
    $("#requests-in-progress"),
    '/grant_requests/data_table/in_progress',
    "There are currently no requests in progress.",
    true
  );
  requestsInProgressTable.render();
});

$(document).on("ajax:success", "[data-behavior~=grant_request_delete_link]", function(data, status, xhr) {
  let link_row = $(this).parents("tr");
  let data_table = $(this).parents("table").DataTable();

  data_table.row(link_row).remove();
  data_table.draw();
});
